import {
    FETCH_SERVICE_REQUEST,
    FETCH_SERVICE_SUCCESS,
    FETCH_SERVICE_FAILURE,
} from '../actions';

const INIT_STATE = {
    loading: false,
    featuresUrl: null,
    featureUpdateUrl: null,
    error: null,
};
const serviceReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_SERVICE_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_SERVICE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                featuresUrl: action.payload.featuresUrl,
                featureUpdateUrl: action.payload.featureUpdateUrl,
            };
        case FETCH_SERVICE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default serviceReducer;
